import { TextSelection } from '@tiptap/pm/state';
import { get_dynamic_styles } from '../../../constant/DynamicStyles';
import { useRouter } from 'next/router';

export const ToCItem = ({ item, onItemClick, styles }) => {
  const router = useRouter();

  const styles_to_use = item?.isActive
    ? styles?.selected_toc_item_style
    : styles?.toc_item_style;

  return (
    <div
      id={item?.id}
      style={{
        ...get_dynamic_styles(styles_to_use),
      }}
    >
      <a
        href={`#${item?.id}`}
        onClick={(e) => onItemClick(e, item.id)}
        data-item-index={item.itemIndex}
      >
        {item.textContent}
      </a>
    </div>
  );
};

export const ToCEmptyState = () => {
  return <div className="w-full h-full"></div>;
};

export const ToC = ({ items = [], editor, styles }) => {
  if (items.length === 0) {
    return <ToCEmptyState />;
  }

  const onItemClick = (e, id) => {
    e.preventDefault();

    if (editor) {
      const element = editor.view.dom.querySelector(`[data-toc-id="${id}"`);
      const pos = editor.view.posAtDOM(element, 0);

      // set focus
      const tr = editor.view.state.tr;

      tr.setSelection(new TextSelection(tr.doc.resolve(pos)));

      editor.view.dispatch(tr);

      editor.view.focus();

      if (history.pushState) {
        // eslint-disable-line
        history.pushState(null, null, `#${id}`); // eslint-disable-line
      }

      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      {items.map((item, i) => (
        <ToCItem
          onItemClick={onItemClick}
          key={item.id}
          item={item}
          index={i + 1}
          styles={styles}
        />
      ))}
    </>
  );
};
